import React from "react";
import { LIST_OF_ITEMS } from "./index.content";
import Container from "../../common/UI/Container";
import Countries from "./Countries";
import Item from "./Item";
import "./index.scss";

const STATIC_LIST = LIST_OF_ITEMS.map((data, index) => (
  <Item key={data.title} {...data} index={index} />
));

const ProValue = () => (
  <section className="PgESM-PV">
    <Container mode="standard">
      <h2 className="PgESM-PV__title">
        {"Obtén todo lo que necesitas para vender en 14 mercados de Amazon"}
      </h2>
      <Countries />
      <div className="PgESM-PV-list">{STATIC_LIST}</div>
    </Container>
  </section>
);

export default ProValue;
